import React, { useEffect, useRef, useState } from "react";
import { Button, Container, Modal, Spinner, Table } from "react-bootstrap";
import {
  Autocomplete,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
  createFilterOptions,
} from "@mui/material";
import TableContent from "../../table/table";
import { useDispatch, useSelector } from "react-redux";
import { GetAllEmployeeAction } from "../../../../redux/actions/employeeActions";
import {
  CreateSalaryAction,
  DeleteSalaryAction,
  GetAllSalaryAction,
  UpdateSalaryAction,
} from "../../../../redux/actions/SalaryAction";
import { useReactToPrint } from "react-to-print";
import notify from "../../../Notifcation";
import { ToastContainer } from "react-toastify";
import Pagination from "../../../Utility/Pagination/Pagination";
const filter = createFilterOptions();
const Enter = ({
  Datee,
  setDate,
  State,
  setState,
  jopType,
  setjopType,
  EmployeeName,
  setEmployeeName,
  jopTypeNumber,
  setjopTypeNumber,
  mainSalary,
  setmainSalary,
  kpis,
  setkpis,
  deductions,
  setdeductions,
  net,
  setnet,
  borrow,
  setborrow,
  note,
  setnote,
  isEdit,
  setIsEdit,
  Eye,
  setEye,
  SalaryId,
  setSalaryId,
  userData,
}) => {
  const Months = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
  const [Search, setSearch] = useState("");
  const myDivRefWorkcom = useRef();
  const AllEmplyee = useSelector((state) => state.EmployeeR.GetEmployee);
  const All = useSelector((state) => state.SalaryR.GetSalary);

  const PageSize = 7;
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const [isPress, setIsPress] = useState(false);
  useEffect(() => {
    dispatch(GetAllSalaryAction());
    dispatch(GetAllEmployeeAction());
  }, []);
  useEffect(() => {
    dispatch(GetAllSalaryAction(`SearchTerm=${Search}&PageSize=${PageSize}`));
  }, [Search]);

  const [showDelete, setshowDelete] = useState(false);
  const onPress = async (page) => {
    await dispatch(
      GetAllSalaryAction({ pageNumber: page, pageSize: PageSize })
    );
  };
  const current = All?.currentPage;

  const handleCloseDelete = () => setshowDelete(false);
  const handleShoweDelete = (itemid) => {
    setshowDelete(true);
    setSalaryId(itemid);
  };

  const parse = (val) => parseFloat(val) || 0;

  // Recalculate net value on change
  useEffect(() => {
    const calculatedNet =
      parse(mainSalary) + parse(kpis) - parse(deductions) - parse(borrow);
    setnet(calculatedNet);
  }, [mainSalary, kpis, deductions, borrow]);

  const handelDeleteItem = async () => {
    setIsPress(true);
    setLoading(true);
    await dispatch(DeleteSalaryAction(SalaryId));
    setLoading(false);
    setSalaryId(null);
    setshowDelete(false);
    setIsPress(false);
  };


  const handlesubmit = async (e) => {
    e.preventDefault();
    if (Datee === "" || EmployeeName === null) {
      notify("من فضلك اكمل البيانات المطلوبة", "error");
      return;
    }

    if (userData.subscriptionType === "Ended-Subscription") {
      notify("تم انتهاء اشتراكك برجاء التجديد", "error");
      return;
    }
    if (
      userData.isActive === false &&
      userData.subscriptionType === "IsPaid-Subscription"
    ) {
      notify("تم انتهاء اشتراكك برجاء التجديد", "error");
      return;
    }
    if (
      userData.isActive === false &&
      userData.subscriptionType === "IsFree-Subscription"
    ) {
      notify("تم انتهاء اشتراكك برجاء التجديد", "error");
      return;
    }
    if (
      userData.isActive === false &&
      userData.subscriptionType === "IsPaid-Subscription"
    ) {
      notify("تم انتهاء اشتراكك برجاء التجديد", "error");
      return;
    }
    if (
      userData.isActive === false &&
      userData.subscriptionType === "IsFree-Subscription"
    ) {
      notify("تم انتهاء اشتراكك برجاء التجديد", "error");
      return;
    }
    if (
      userData.subscriptionType === "User-not-subscriped" &&
      All.data &&
      All.data.length > 14
    ) {
      notify("غير مسموح بأضافة اكثر من 15 من الاجازات إشترك للتفعيل ", "error");
      return;
    }
    if (
      userData.subscriptionType === "User-not-subscriped" &&
      current > 1 &&
      All.data.length > 14
    ) {
      notify("غير مسموح بأضافة اكثر من 15 من الاجازات إشترك للتفعيل ", "error");
      return;
    }
    setIsPress(true);
    setLoading(true);
    const Data = {
      Date: Datee,
      jopType: jopType,
      jopTypeNumber: jopTypeNumber,
      mainSalary: mainSalary,
      kpis: kpis,
      deductions: deductions,
      net: net,
      borrow: borrow,
      note: note,
      employeeId: EmployeeName.id,
    };

    await dispatch(CreateSalaryAction(Data));
    setDate("");
    setEmployeeName("");
    setjopType("");
    setjopTypeNumber("");
    setmainSalary("");
    setkpis("");
    setdeductions("");
    setnet("");
    setborrow("");
    setnote("");
    setSalaryId("");

    setIsPress(false);
    setLoading(false);
  };
  const handleUpdate = async (e) => {
    e.preventDefault();
    if (Datee === "" || EmployeeName === null) {
      notify("من فضلك اكمل البيانات المطلوبة", "error");
      return;
    }

    if (userData.subscriptionType === "Ended-Subscription") {
      notify("تم انتهاء اشتراكك برجاء التجديد", "error");
      return;
    }
    if (
      userData.isActive === false &&
      userData.subscriptionType === "IsPaid-Subscription"
    ) {
      notify("تم انتهاء اشتراكك برجاء التجديد", "error");
      return;
    }
    if (
      userData.isActive === false &&
      userData.subscriptionType === "IsFree-Subscription"
    ) {
      notify("تم انتهاء اشتراكك برجاء التجديد", "error");
      return;
    }
    if (
      userData.isActive === false &&
      userData.subscriptionType === "IsPaid-Subscription"
    ) {
      notify("تم انتهاء اشتراكك برجاء التجديد", "error");
      return;
    }
    if (
      userData.isActive === false &&
      userData.subscriptionType === "IsFree-Subscription"
    ) {
      notify("تم انتهاء اشتراكك برجاء التجديد", "error");
      return;
    }
    if (
      userData.subscriptionType === "User-not-subscriped" &&
      All.data &&
      All.data.length > 14
    ) {
      notify("غير مسموح بأضافة اكثر من 15 من الاجازات إشترك للتفعيل ", "error");
      return;
    }
    if (
      userData.subscriptionType === "User-not-subscriped" &&
      current > 1 &&
      All.data.length > 14
    ) {
      notify("غير مسموح بأضافة اكثر من 15 من الاجازات إشترك للتفعيل ", "error");
      return;
    }

    setIsPress(true);
    setLoading(true);

    const Data = {
      Date: Datee,
      // employeeId: EmployeeName.id,
      jopType: jopType,
      jopTypeNumber: jopTypeNumber,
      mainSalary: mainSalary,
      kpis: kpis,
      deductions: deductions,
      net: net,
      borrow: borrow,
      note: note,
      id: SalaryId,
    };

    await dispatch(UpdateSalaryAction(Data));
    setDate("");
    setEmployeeName("");
    setjopType("");
    setjopTypeNumber("");
    setmainSalary("");
    setkpis("");
    setdeductions("");
    setnet("");
    setborrow("");
    setnote("");
    setSalaryId("");
    setEye(false);

    setIsPress(false);
    setIsEdit(false);
    setLoading(false);
  };

  const Update = (item) => {
    setEmployeeName({
      name: item.employeeName,
      id: item.employeeId,
    });
    setDate(item.date);

    setjopType(item.jopType);
    setjopTypeNumber(item.jopTypeNumber);
    setmainSalary(item.mainSalary);
    setkpis(item.kpis);
    setdeductions(item.deductions);
    setnet(item.net);
    setborrow(item.borrow);
    setnote(item.note);
    setSalaryId(item.id);
    setIsEdit(true);
    setEye(false);
  };
  const Showw = (item) => {
    setEmployeeName({
      name: item.employeeName,
      id: item.employeeId,
    });
    setDate(item.date);
    setjopType(item.jopType);
    setjopTypeNumber(item.jopTypeNumber);
    setmainSalary(item.mainSalary);
    setkpis(item.kpis);
    setdeductions(item.deductions);
    setnet(item.net);
    setborrow(item.borrow);
    setnote(item.note);
    setIsEdit(false);
    setEye(true);
  };

  const res = useSelector((state) => state.SalaryR.AddSalary);
  const UP = useSelector((state) => state.SalaryR.UpdateSalary);
  const DEL = useSelector((state) => state.SalaryR.DeleteSalary);

  useEffect(() => {
    if (loading === false) {
      setTimeout(() => setLoading(true), 2000);
      if (res) {
        if (res.status === 200 || res.status === 201) {
          if (
            res.data &&
            res.data.responseMessage === "Great, salary created Successfully"
          ) {
            dispatch(GetAllSalaryAction(`PageSize=${PageSize}`));
            notify("تم اضافة البيانات بنجاح", "success");
          } else if (
            res.data &&
            res.data.responseMessage ===
              "sorry, this user have an exist salary record"
          ) {
            notify("تم اضافة المرتب لهذا الموظف ", "error");
          }
        } else if (res.status !== 200 || res.status !== 201) {
          // if (res.data && res.data.responseMessage==="PhoneNumber or Password is incorrect!") {
          //   notify("خطأ في كلمة السر او رقم الهاتف", "error");
          // }
          // else
          notify("حدث خطأ حاول مرة اخرى", "warn ");
        }
        // setLoading(true);
      }
      if (UP) {
        if (UP.status === 200 || UP.status === 201) {
          if (
            UP.data &&
            UP.data.responseMessage === "Great, salary updated Successfully"
          ) {
            dispatch(GetAllSalaryAction(`PageSize=${PageSize}`));
            notify("تم تحديث البيانات بنجاح", "success");
          } else if (
            UP.data &&
            UP.data.responseMessage === "sorry, no salary record to update"
          ) {
            dispatch(GetAllSalaryAction(`PageSize=${PageSize}`));
            notify("لا يمكن تعديل المرتب للموظف", "warn");
          }
        } else if (UP.status !== 200 || UP.status !== 201) {
          if (
            UP.data &&
            UP.data.responseMessage ===
              "can't update the admin request because you exceeded your limit of holidays"
          ) {
            dispatch(GetAllSalaryAction(`PageSize=${PageSize}`));
            notify("تم تخطى الحد المسموح من عدد ايام الاجازات", "warn");
          } else notify("حدث خطأ حاول مرة اخرى", "error");
        }
        // setLoading(true);
      }
      if (DEL) {
        if (DEL.statusCode === 200 || DEL.statusCode === 201) {
          if (
            DEL &&
            DEL.responseMessage === "Great, salary deleted Successfully"
          ) {
            dispatch(GetAllSalaryAction(`PageSize=${PageSize}`));
            notify("تم حذف البيانات بنجاح", "success");
          }
        } else if (DEL.statusCode !== 200 || DEL.statusCode !== 201) {
          // if (res.data && res.data.responseMessage==="PhoneNumber or Password is incorrect!") {
          //   notify("خطأ في كلمة السر او رقم الهاتف", "error");
          // }
          // else
          notify("حدث خطأ حاول مرة اخرى", "error");
        }
        // setLoading(true);
      }
    }
  }, [loading]);

  return (
    <>
      <div className="enterr">
        <Container>
          <div className="inputs-container">
            <div className="inp-container">
              <div className="dateee">{Datee ? Datee : null}</div>
              <i className="ty fa-solid fa-calendar-days"></i>
              <TextField
                label={
                  <Typography sx={{ fontSize: "18px", fontFamily: "Almarai" }}>
                    التاريخ
                    <span style={{ color: "red", fontSize: "21px" }}>*</span>
                  </Typography>
                }
                variant="outlined"
                type="date"
                value={Datee}
                onChange={(e) => setDate(e.target.value)}
              />
            </div>
            <div className="inp-container">
              <Autocomplete
                value={EmployeeName}
                disabled={isEdit}
                onChange={(event, newValue) => {
                  if (typeof newValue === "string") {
                    setEmployeeName({
                      name: newValue,
                    });
                  } else if (newValue && newValue.inputValue) {
                    // Create a new value from the user input
                    setEmployeeName({
                      name: newValue.inputValue,
                    });
                  } else {
                    setEmployeeName(newValue);
                    setjopType(newValue.jopType);
                    setmainSalary(newValue.salary);
                  }
                }}
                filterOptions={(options, params) => {
                  const filtered = filter(options, params);

                  const { inputValue } = params;
                  // Suggest the creation of a new value
                  const isExisting = options.some(
                    (option) => inputValue === option.name
                  );
                  if (inputValue !== "" && !isExisting) {
                    filtered.push({
                      inputValue,
                      // title: `لا توجد حسابات بهذا الاسم"${inputValue}"`,
                    });
                  }

                  return filtered;
                }}
                selectOnFocus
                clearOnBlur
                handleHomeEndKeys
                id="free-solo-with-text-demo"
                options={
                  Array.isArray(AllEmplyee && AllEmplyee.data)
                    ? AllEmplyee.data.filter((e) => e.isAccountActive === true)
                    : []
                }
                getOptionLabel={(option) => {
                  // Value selected with enter, right from the input
                  if (typeof option === "string") {
                    return option;
                  }
                  // Add "xxx" option created dynamically
                  if (option.inputValue) {
                    return option.inputValue;
                  }
                  // Regular option
                  return option.name;
                }}
                renderOption={(props, option) => (
                  <li {...props}>{option.name}</li>
                )}
                sx={{ width: 300 }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label={
                      <Typography
                        sx={{ fontSize: "18px", fontFamily: "Almarai" }}>
                        اسم الموظف
                        <span style={{ color: "red", fontSize: "21px" }}>
                          *
                        </span>
                      </Typography>
                    }
                  />
                )}
              />
            </div>

            <div className="inp-container">
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">
                  {" "}
                  نوع العمل
                </InputLabel>
                <Select
                
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={jopType}
                  label={"نوع العمل"}
                  disabled
                  // onChange={(e) => setjopType(e.target.value)}
                  >
                  <MenuItem value={"بالشهر"}>بالشهر</MenuItem>
                  <MenuItem value={"بالأسبوع"}>بالأسبوع</MenuItem>
                  <MenuItem value={"باليوم"}>باليوم</MenuItem>
                  <MenuItem value={"بالساعة"}>بالساعة</MenuItem>
                  <MenuItem value={"حسب الأتفاق"}>حسب الأتفاق</MenuItem>
                </Select>
              </FormControl>
            </div>
            {jopType === "" || jopType === "بالشهر" ? null : (
              <div className="inp-container">
                <TextField
                  label={
                    <Typography
                      sx={{ fontSize: "18px", fontFamily: "Almarai" }}>
                      {jopType === "بالساعة"
                        ? "عدد الساعات "
                        : jopType === "باليوم"
                        ? "عدد الأيام"
                        : jopType === "بالأسبوع"
                        ? "عدد الأسابيع"
                        : jopType === "حسب الأتفاق"
                        ? "حسب الأتفاق"
                        : ""}
                      <span style={{ color: "red", fontSize: "21px" }}>*</span>
                    </Typography>
                  }
                  variant="outlined"
                  value={jopTypeNumber}
                  onChange={(e) => setjopTypeNumber(e.target.value)}
                  //   className="ww"
                />
              </div>
            )}
            {jopType === "بالشهر" ? (
              <div className="inp-container">
                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label">
                    {" "}
                    <Typography
                      sx={{ fontSize: "18px", fontFamily: "Almarai" }}>
                      الشهور
                      <span style={{ color: "red", fontSize: "21px" }}>*</span>
                    </Typography>
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={jopTypeNumber}
                    label={
                      <Typography
                        sx={{ fontSize: "18px", fontFamily: "Almarai" }}>
                        الشهور
                        <span style={{ color: "red", fontSize: "21px" }}>
                          *
                        </span>
                      </Typography>
                    }
                    onChange={(e) => setjopTypeNumber(e.target.value)}>
                    {jopType === "بالشهر"
                      ? Months.map((m, idx) => (
                          <MenuItem key={idx} value={m}>
                            {m}
                          </MenuItem>
                        ))
                      : null}
                  </Select>
                </FormControl>
              </div>
            ) : null}
            {/* <div className="inp-container">
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">
                  {" "}
                  <Typography sx={{ fontSize: "18px", fontFamily: "Almarai" }}>
                  {jopType === "بالساعة"
                        ? "عدد الساعات "
                        : jopType === "باليوم"
                        ? "عدد الأيام"
                        : jopType === "بالشهر"
                        ? " الشهور"
                        : jopType === "بالأسبوع"
                        ? "عدد الأسابيع"
                        : jopType === "حسب الأتفاق"
                        ? "عدد"
                        : "عدد"}
                    <span style={{ color: "red", fontSize: "21px" }}>*</span>
                  </Typography>
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={State}
                  label={
                    <Typography
                      sx={{ fontSize: "18px", fontFamily: "Almarai" }}
                    >
                         {jopType === "بالساعة"
                        ? "عدد الساعات "
                        : jopType === "باليوم"
                        ? "عدد الأيام"
                        : jopType === "بالشهر"
                        ? " الشهور"
                        : jopType === "بالأسبوع"
                        ? " الأسابيع"
                        : jopType === "حسب الأتفاق"
                        ? "عدد"
                        : "عدد"}
                      <span style={{ color: "red", fontSize: "21px" }}>*</span>
                    </Typography>
                  }
                  onChange={(e) => setState(e.target.value)}
                >
                  {jopType === "بالساعة"
                    ? Hours.map((h, idx) => (
                        <MenuItem key={idx} value={h}>
                          {h}
                        </MenuItem>
                      ))
                    : jopType === "باليوم"
                    ? Dayes.map((d, idx) => (
                        <MenuItem key={idx} value={d}>
                          {d}
                        </MenuItem>
                      ))
                    : jopType === "بالشهر"
                    ? Months.map((m, idx) => (
                        <MenuItem key={idx} value={m}>
                          {m}
                        </MenuItem>
                      ))
                    : null}
                </Select>
              </FormControl>
            </div> */}
            <div className="inp-container">
              <TextField
                label={
                  <Typography sx={{ fontSize: "18px", fontFamily: "Almarai" }}>
                    الاساسي
                    <span style={{ color: "red", fontSize: "21px" }}>*</span>
                  </Typography>
                }
                variant="outlined"
                value={mainSalary}
                onChange={(e) => setmainSalary(e.target.value)}
                type="number"
                //   className="ww"
              />
            </div>
            <div className="inp-container">
              <TextField
                label="مكافات"
                variant="outlined"
                value={kpis}
                onChange={(e) => setkpis(e.target.value)}
                type="number"
                //   className="ww"
              />
            </div>
            <div className="inp-container">
              <TextField
                label="خصومات"
                variant="outlined"
                value={deductions}
                onChange={(e) => setdeductions(e.target.value)}
                type="number"
                //   className="ww"
              />
            </div>
            <div className="inp-container">
              <TextField
                label="سلف"
                variant="outlined"
                value={borrow}
                onChange={(e) => setborrow(e.target.value)}
                type="number"
                //   className="ww"
              />
            </div>
            <div className="inp-container">
              <TextField
                label={"صافي القيمة"}
                variant="outlined"
                value={net}
                onChange={(e) => setnet(e.target.value)}
                //   className="ww"
              />
            </div>
            <div className="inp-container">
              <TextField
                label={"ملاحظات"}
                variant="outlined"
                value={note}
                onChange={(e) => setnote(e.target.value)}

                //   className="ww"
              />
            </div>
            <div className="inp-container"></div>
            <div className="inp-container"></div>
          </div>
          {Eye ? null : (
              <>
              {isEdit ? (
                <>
                  {loading && isPress ? (
                    <button className="buttonadd">
                      <Spinner />
                    </button>
                  ) : (
                    <button className="buttonadd" onClick={handleUpdate}>
                      تعديل
                    </button>
                  )}
                </>
              ) : (
                <>
                  {loading && isPress ? (
                    <button className="buttonadd">
                      <Spinner />
                    </button>
                  ) : (
                    <button className="buttonadd" onClick={handlesubmit}>
                      إضافة
                    </button>
                  )}
                </>
              )}
            </>
          )}{" "}
          <div className="inputs-container ddl">
            <div className="inp-container ">
              {" "}
              <TextField
                label="ابحث"
                inputProps={{ maxLength: 120 }}
                type="text"
                variant="outlined"
                onChange={(e) => setSearch(e.target.value)}
                value={Search}
                //   className="ww"
              />
              <i className="ty fa-solid fa-magnifying-glass"></i>
            </div>{" "}
            <div className="inp-container"></div>
            <div className="inp-container"></div>
          </div>
        </Container>{" "}
        <Table
          id="my-table"
          className="maint"
          responsive
          striped
          bordered
          hover>
          <thead>
            <tr>
              <th>
                التاريخ<i className="fa-solid fa-hashtag"></i>
              </th>
              <th>
                اسم الموظف <i className="fa-solid fa-hashtag"></i>
              </th>
              <th>
                نوع العمل <i className="fa-regular fa-calendar-check"></i>
              </th>
              <th>
                عدد<i className="fa-solid fa-hashtag"></i>
              </th>
              <th>
                الأساسي<i className="fa-solid fa-hashtag"></i>
              </th>
              <th>
                مكافات<i className="fa-solid fa-hashtag"></i>
              </th>
              <th>
                سلف<i className="fa-solid fa-hashtag"></i>
              </th>
              <th>
                خصومات<i className="fa-solid fa-hashtag"></i>
              </th>
              <th>
                صافي القيمة<i className="fa-regular fa-calendar-check"></i>
              </th>
              <th>
                ملاحظات <i className="fa-regular fa-calendar-check"></i>
              </th>

              <th className="icon-w"> </th>
              <th className="icon-w"> </th>
              <th className="icon-w"> </th>
            </tr>
          </thead>
          <tbody>
            {All && All.data && All.data.length > 0
              ? All.data.map((item, idx) => {
                  // ForceCount = ALL.TotalPages - 1;
                  return (
                    <tr key={idx} onDoubleClick={() => Update(item)}>
                      <td>{new Date(item.date).toLocaleDateString("en-GB")}</td>
                      <td>{item.employeeName}</td>
                      <td>{item.jopType}</td>
                      <td>{item.jopTypeNumber}</td>
                      <td>{item.mainSalary}</td>
                      <td>{item.kpis}</td>
                      <td>{item.borrow}</td>
                      <td>{item.deductions}</td>
                      <td>{item.net}</td>

                      <td>{item.note}</td>

                      <td className="icon-w" onClick={() => Update(item)}>
                        <i
                          className="fa fa-solid fa-pen-to-square icon-blue"
                          style={{ color: "#333" }}></i>
                      </td>
                      <td className="icon-w">
                        {" "}
                        <i
                          onClick={() => handleShoweDelete(item.id)}
                          className="fs fa-solid fa-trash-can icon-red"
                          style={{ color: "#333" }}></i>
                      </td>
                      <td className="icon-w">
                        <i
                          onClick={() => Showw(item)}
                          className="fa-solid fa-eye"
                          style={{ color: "#333" }}></i>
                      </td>
                    </tr>
                  );
                })
              : null}
          </tbody>
        </Table>
        <ToastContainer autoClose={1200} />
        <Pagination
          onPress={onPress}
          PageSize={PageSize}
          PageCount={All ? All.totalPages : null}
          // ForceCount={ForceCount}
          // itemsPerPage={2}
          // items={FilesDetails.data}
        />
        {/* <button className="buttonadd">تصدير</button> */}
      </div>
      <div className="mod">
        <Modal
          show={showDelete}
          onHide={handleCloseDelete}
          backdrop="static"
          centered
          contentClassName="cont"
          keyboard={false}
          style={{ width: "100%", margin: "0px auto", textAlign: "center" }}>
          {/* <Modal.Header closeButton>
                            <Modal.Title> </Modal.Title>
                          </Modal.Header> */}
          <Modal.Body>هل تريد الحذف ؟ </Modal.Body>

          <Modal.Footer>
            <Button
              variant="secondary"
              className="close"
              onClick={handleCloseDelete}>
              إغلاق
            </Button>
            <Button
              variant="primary"
              className="edit"
              onClick={handelDeleteItem}>
              موافق
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    </>
  );
};
export default Enter;
